import {ThresholdLimit} from '@domain/kiln-monitoring'

export const statusOptions = [
  ThresholdLimit.HIGH_HIGH,
  ThresholdLimit.HIGH,
  ThresholdLimit.LOW,
  ThresholdLimit.LOW_LOW,
  'ModelBreach'
] as const

export type StatusOption = (typeof statusOptions)[number]

export type SignalChart = {
  id: string
  signalIds: string[]
  type: 'single' | 'combined'
}

export enum SignalTreeViews {
  SIGNALS = 'signals',
  GROUPS = 'groups'
}

export const filterOptions = ['Status', 'Provider'] as const
export type FilterOption = (typeof filterOptions)[number]
